const englishSpellingLUT: { us: string; gb: string }[] = [
  { gb: "analyse", us: "analyze" },
  { gb: "analysed", us: "analyzed" },
  { gb: "analysing", us: "analyzing" },
  { gb: "apologise", us: "apologize" },
  { gb: "artefact", us: "artifact" },
  { gb: "armour", us: "armor" },
  { gb: "catalogue", us: "catalog" },
  { gb: "centre", us: "center" },
  { gb: "centred", us: "centered" },
  { gb: "centres", us: "centers" },
  { gb: "centring", us: "centering" },
  { gb: "colour", us: "color" },
  { gb: "coloured", us: "colored" },
  { gb: "colouring", us: "coloring" },
  { gb: "colours", us: "colors" },
  { gb: "cosy", us: "cozy" },
  { gb: "counsellor", us: "counselor" },
  { gb: "defence", us: "defense" },
  { gb: "endeavour", us: "endeavor" },
  { gb: "endeavoured", us: "endeavored" },
  { gb: "favourite", us: "favorite" },
  { gb: "fibre", us: "fiber" },
  { gb: "flavour", us: "flavor" },
  { gb: "grey", us: "gray" },
  { gb: "honour", us: "honor" },
  { gb: "honoured", us: "honored" },
  { gb: "honouring", us: "honoring" },
  { gb: "honours", us: "honors" },
  { gb: "humour", us: "humor" },
  { gb: "jewellery", us: "jewelry" },
  { gb: "labour", us: "labor" },
  { gb: "laboured", us: "labor" },
  { gb: "labouring", us: "labouring" },
  { gb: "labours", us: "labors" },
  { gb: "licence", us: "license" },
  { gb: "licences", us: "licenses" },
  { gb: "marvellous", us: "marvelous" },
  { gb: "neighbour", us: "neighbor" },
  { gb: "neighbour's", us: "neighbor's" },
  { gb: "neighbours", us: "neighbors" },
  { gb: "offence", us: "offense" },
  { gb: "organise", us: "organize" },
  { gb: "plough", us: "plow" },
  { gb: "pretence", us: "pretense" },
  { gb: "programme", us: "program" },
  { gb: "realise", us: "realize" },
  { gb: "realised", us: "realized" },
  { gb: "realises", us: "realizes" },
  { gb: "recognise", us: "recognize" },
  { gb: "saviour", us: "savior" },
  { gb: "savior's", us: "saviour's" },
  { gb: "sceptical", us: "skeptical" },
  { gb: "splendour", us: "splendor" },
  { gb: "travelled", us: "traveled" },
  { gb: "traveller", us: "traveler" },
  { gb: "travelling", us: "traveling" },
];

export function applyCorrectEnglish(
  phrase: string,
  destinationCountry: string,
): string {
  const country = destinationCountry.toLowerCase();
  const isUpperCase = (word: string) => word === word.toUpperCase();
  const isCapitalized = (word: string) => word[0] === word[0].toUpperCase();

  return phrase
    .split(" ")
    .map((word) => {
      const punctuationMatch = word.match(/[.,!?]$/);
      const punctuation = punctuationMatch ? punctuationMatch[0] : ""; // Extract trailing punctuation
      const strippedWord = word.slice(0, word.length - punctuation.length); // Remove punctuation

      const match = englishSpellingLUT.find(
        (entry) =>
          (country === "us"
            ? entry.gb.toLowerCase()
            : entry.us.toLowerCase()) === strippedWord.toLowerCase(),
      );

      if (match) {
        const replacement = country === "us" ? match.us : match.gb;

        let correctedWord = replacement.toLowerCase();

        if (isUpperCase(strippedWord)) {
          correctedWord = replacement.toUpperCase();
        } else if (isCapitalized(strippedWord)) {
          correctedWord =
            replacement[0].toUpperCase() + replacement.slice(1).toLowerCase();
        }

        return correctedWord + punctuation;
      }

      return word;
    })
    .join(" ");
}
